import '@emotion/react';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { mediaQuery } from '../../../helpers/media.js';
import '../../../helpers/animation.js';

var _a, _b;
var ProductCardContainer = styled.article({
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    backgroundColor: tokens.color.yeezy[0],
    cursor: "pointer",
    height: "100%",
});
var ImageContainer = styled.div({
    position: "relative",
    overflow: "hidden",
    maxWidth: "100%",
    width: "100%",
    height: "100%",
    isolation: "isolate",
    aspectRatio: "1",
    img: {
        transition: "all 0.4s ease-in",
        maxWidth: "100%",
        maxHeight: "100%",
        height: "100%",
        width: "100%",
    },
    ":hover": {
        img: {
            transform: "scale(1.05)",
        },
    },
});
var Image = styled.img({
    width: "100%",
    height: "100%",
    aspectRatio: "1",
});
var Indicators = styled.div({
    position: "absolute",
    top: tokens.spacing[3],
    right: tokens.spacing[3],
    zIndex: tokens.zIndex.above,
});
var Footer = styled.footer((_a = {
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        maxWidth: "61ch",
        gap: tokens.spacing[2],
        width: "100%",
        minHeight: "124px"
    },
    _a[mediaQuery.m.min] = {
        minHeight: "104px",
    },
    _a.padding = "0 ".concat(tokens.spacing[5], " ").concat(tokens.spacing[5]),
    _a.span = {
        color: tokens.color.airJordan.p,
    },
    _a["span:nth-of-type(2)"] = (_b = {
            color: tokens.color.airJordan[600],
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            wordBreak: "break-word",
            WebkitLineClamp: 3
        },
        _b[mediaQuery.m.min] = { WebkitLineClamp: 2 },
        _b),
    _a["span:nth-of-type(3)"] = {
        marginTop: "auto",
    },
    _a));

export { Footer, Image, ImageContainer, Indicators, ProductCardContainer };
//# sourceMappingURL=ProductCard.styles.js.map
